import Paginate from 'vuejs-paginate';

if ($('#component-user-connections').length) {
    var app = new Vue({
        el: '#component-user-connections',
        components: {
            'paginate': Paginate
        },
        data: {
            date: '',
            invitations: [],
            loading: false,
            pagination: {
                lastPage: 0,
                page: 1,
                from: 0,
                to: 0,
                total: 0
            },
            connectionsPagination: {
                lastPage: 0,
                page: 1,
                from: 0,
                to: 0,
                total: 0
            },
            filter: 1,
            connections: [],
            connectionsLoading: false,
            count: '',
            showConnectHeader: false
        },
        methods: {
            getInvitations(page) {
                this.loading = true;
                this.invitations = [];
                axios.get('/api/v1/get-invitations', {
                    params: {
                        page: page
                    }
                }).then((response) => {
                    if (response.data) {
                        let data;
                        data = response.data.invitations;
                        this.invitations = data.data;
                        this.pagination.lastPage = data.last_page;
                        this.pagination.page = data.current_page;
                        this.pagination.from = data.from;
                        this.pagination.to = data.to;
                        this.pagination.total = data.total;
                    }
                    this.loading = false;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            getConnections(page) {
                this.connectionsLoading = true;
                this.connections = [];
                axios.get('/api/v1/get-connections', {
                    params: {
                        page: page,
                        filter: this.filter
                    }
                }).then((response) => {
                    if (response.data) {
                        let data;
                        data = response.data.connections;
                        this.connections = data.data;
                        this.connectionsPagination.lastPage = data.last_page;
                        this.connectionsPagination.page = data.current_page;
                        this.connectionsPagination.from = data.from;
                        this.connectionsPagination.to = data.to;
                        this.connectionsPagination.total = data.total;
                    }
                    this.connectionsLoading = false;
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            countRequests() {
                axios.get('/api/v1/count-requests')
                    .then((response) => {
                        if (response.data.full != 1) {
                            this.count = response.data.count
                            this.date = response.data.date;
                            this.showConnectHeader = true;
                        }
                    }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            removeConnection(id) {
                axios.post('/api/v1/remove-connection', {
                    user_id: id
                }).then((response) => {
                    this.countRequests();
                    this.getConnections(this.connectionsPagination.page);
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            acceptConnection(id) {
                axios.post('/api/v1/accept-connection', {
                    user_id: id
                }).then((response) => {
                    this.getInvitations(this.pagination.page);
                    this.getConnections(this.connectionsPagination.page);
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            declineConnection(id) {
                axios.post('/api/v1/decline-connection', {
                    user_id: id
                }).then((response) => {
                    this.getInvitations(this.pagination.page);
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            paginate(page) {
                this.getInvitations(page);
            },
            connectionsPaginate(page) {
                this.getConnections(page);
            },
            getBorder(status) {
                if (status == 'Connected') {
                    return "1px solid #2CC34F";
                } else if (status == 'Declined') {
                    return "1px solid red";
                }
            },
            getColor(status) {
                if (status == 'Connected') {
                    return "#2CC34F";
                } else if (status == 'Declined') {
                    return "red";
                }
            },
            getWidth(count) {
                return count * 20 + '%';
            },
            getDisabled(status) {
                if (status == 'Pending' || status == 'Declined') {
                    return 1;
                } else if (status == 'Connected') {
                    return 0;
                }
            },
            getTitle(status) {
                if (status == 'Connected') {
                    return "Remove connection";
                } else if (status == 'Pending') {
                    return "Cancel request";
                }
            },
            errorHandler(error) {
                if (error.response && typeof error.response.data === 'string') {
                    this.$toasted.error(error.response.data);
                } else {
                    this.$toasted.error(error.response.data.message);
                }
            },
        },
        mounted() {
            this.countRequests();
            this.getInvitations(1);
            this.getConnections(1);
        }
    });
}